'use client';
import dynamic from 'next/dynamic';
import EducationSection from '../components/home/EducationSection';
import HeroSection from '../components/home/HeroSection';
import MeetBoomersSection from '../components/home/MeetBoomersSection';
import Divider from '../components/ui/Divider';
import { type ViewportProps, withViewport } from '../hooks/useViewport';

// Dynamically import sections that are not immediately visible
const VisionSection = dynamic(
  () => import('../components/home/VisionSection'),
  {
    loading: () => <div className='h-screen animate-pulse bg-gray-900' />,
  },
);

const TokenSection = dynamic(() => import('../components/home/TokenSection'), {
  loading: () => <div className='h-screen animate-pulse bg-gray-900' />,
});

const NFTSection = dynamic(() => import('../components/home/NFTSection'), {
  loading: () => <div className='h-screen animate-pulse bg-gray-900' />,
});

const CommunityHubSection = dynamic(
  () => import('../components/home/CommunityHubSection'),
  {
    loading: () => <div className='h-screen animate-pulse bg-gray-900' />,
  },
);

function Home({ isClient, isMobile, isPWA }: ViewportProps) {
  return (
    <main className="relative">
      <div className="relative">
        <HeroSection />
      </div>
      <Divider variant="gradient" />
      <div className="relative">
        <MeetBoomersSection />
      </div>
      <Divider variant="gradient-blur" />
      <div className="relative">
        <EducationSection />
      </div>
      <Divider variant="gradient" />
      <div className="relative">
        <VisionSection />
      </div>
      <Divider variant="gradient" />
      <div className="relative">
        <TokenSection />
      </div>
      <Divider variant="gradient" />
      <div className="relative">
        <NFTSection />
      </div>
      <Divider variant="gradient-blur" />
      <div className="relative">
        <CommunityHubSection />
      </div>
    </main>
  );
}

export default withViewport(Home);
